// extracted by mini-css-extract-plugin
export default {"melodyVideo":"hP-z","isFullWidth":"iP-z","landingPageVideo":"jP-z","play":"kP-z","iframeVideo":"lP-z","playHidden":"mP-z","fullwidth":"nP-z"};